import React, { useState, useEffect, useCallback, useRef } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import constClass from '../../Constants/Constants';
import Loading from '../Loading/Loading';
import util from 'util';
import { useHistory } from 'react-router-dom';

// let membership_id = null;

const StampCard = ({ siteId, mallId, shopCode, customerId, lineId, liffAccessToken, setting, stampRef, ticketClick }) => {
  const [stampCardMaster, setStampCardMaster] = useState([]);
  const [loading, setLoading] = useState(false);
  const [stamp, setStamp] = useState({});
  const [point, setPoint] = useState(false);
  const [getPoint, setGetPoint] = useState(false);
  const [ticket, setTicket] = useState(false);
  const imageRef = useRef();
  const history = useHistory();

  //バックエンドサーバから会員に関する情報を取得
  const refreshData = useCallback(async () => {
    try {
      //各データ取得APIを先に実行
      const stamp_master_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/stamp/master/list/line`, { site_id: siteId, line_id: liffAccessToken , mall_id: mallId });
      const stamp_list_promise = axios.post(`${process.env.REACT_APP_BACKEND_URL}/stamp/list/line/`, { site_id: siteId, line_id: liffAccessToken, customer_id: customerId, mall_id: mallId });

      const stamp_master_data = (await stamp_master_promise).data;
      const stamp_list_data = (await stamp_list_promise).data;

      var stampCard = {};
      var t_stamp = stamp_list_data.t_stamp || [];
      var stampSum = {};
      var index = {};

      // スタンプカード種別ごとにスタンプ状況を設定
      for (const stamp_master of stamp_master_data) {
        stampCard[stamp_master.stampcard_id] = [];
        stampSum[stamp_master.stampcard_id] = {
          sum: t_stamp.filter(p => p.stampcard_id === stamp_master.stampcard_id).reduce((prev, p) => prev + p.point, 0),
          last: t_stamp.filter(p => p.stampcard_id === stamp_master.stampcard_id).reduce((prev, p) => prev < p.stamp_date ? p.stamp_date : prev, "")
        };
        index[stamp_master.stampcard_id] = 0;
        // ポイントデータを1ポイント1要素に変換
        var points = t_stamp.filter(p => p.stampcard_id === stamp_master.stampcard_id).reduce(
          (prev, p) => {
            var s = stamp_master.m_stamp.find(s => s.stamp_id === p.stamp_id);
            var newStamp = stampRef.current ? stampRef.current : {};
            for (var i = 0; i < p.point; i++) {
              prev.push({ image: s ? s.stamp_image_url : null, used: i < p.use_point, new: (p.stampcard_id === newStamp.stampcard_id && p.stamp_id === newStamp.stamp_id && p.stamp_no === newStamp.stamp_no) })
            }
            return prev;
          }
          , []);

        if (points.length > 0) {
          // 獲得しているポイントでループ
          for (var i = 0; i < points.length; i += stamp_master.point_limit) {
            index[stamp_master.stampcard_id] = (i / stamp_master.point_limit);
            var card = { stamp: [], checkFilled: true, checkUsed: true, checkNew: false, stampcard_id: stamp_master.stampcard_id };
            for (var j = 0; j < stamp_master.point_limit; j++) {
              if (i + j < points.length) {
                if (j + 1 === stamp_master.point_limit && stamp_master.stamp_achievementimage_url) {
                  card.stamp.push(points[i + j] ? { image: stamp_master.stamp_achievementimage_url, new: points[i + j].new } : null);
                } else {
                  card.stamp.push(points[i + j] ? { image: points[i + j].image, new: points[i + j].new } : null);
                }
                card.checkUsed = card.checkUsed & points[i + j].used;
                card.checkNew = card.checkNew | points[i + j].new;
              } else {
                card.stamp.push(null);
                card.checkUsed = false;
                card.checkFilled = false;
              }
            }
            stampCard[stamp_master.stampcard_id].push(card);
          }
        } else {
          stampCard[stamp_master.stampcard_id].push({ stamp: (new Array(stamp_master.point_limit)).fill(null), checkFilled: false, checkUsed: false, stampcard_id: stamp_master.stampcard_id });
        }
      }
      setStamp(stampCard);
      setStampCardMaster(stamp_master_data);
    } catch (err) {
      console.log(err);
    }
  }, [siteId, customerId, liffAccessToken, stampRef, mallId]);

  const submitStampCard = useCallback(async (stampcard_id, questionnaire_id) => {
    if (stampcard_id && questionnaire_id) {
      history.push(`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.INPUTENTRY}&stampcard_id=${stampcard_id}&questionnaire_id=${questionnaire_id}`);
    } else if (stampcard_id && !questionnaire_id) {
      // 交換処理
      if (!window.confirm('特典を受け取ります、よろしいですか？')) {
        return;
      }
      try {
        setLoading(true);
        const params = {
          site_id: siteId,
          line_id: liffAccessToken,
          mall_id: mallId,
          stampcard_id,
          questionnaire_id,
        };

        var result = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/stamp/line/use`, params);
        if (result.data.stampcard) {
          if (result.data.point && result.data.ticket) {
            window.alert('受け取りました。');
            await refreshData();
            setPoint(true);
            setTicket(true);
            setGetPoint(result.data.getpoint);
            setLoading(false);
          } else if (result.data.point && result.data.getpoint) {
            window.alert('受け取りました。');
            await refreshData();
            setPoint(true);
            setGetPoint(result.data.getpoint);
            setLoading(false);
          }
          else if (result.data.ticket) {
            window.alert('受け取りました。');
            await refreshData();
            setTicket(true);
            setLoading(false);
          }
        } else {
          if (result.data.message) {
            window.alert(result.data.message);
          } else {
            window.alert("エラーが発生しました。");
          }
          setLoading(false);
        }
      } catch (err) {
        if (err.response && err.response.data && err.response.data.message) {
          // console.log(util.inspect(err));
          window.alert(err.response.data.message);
        } else {
          console.log(util.inspect(err));
          window.alert("エラーが発生しました。");
        }
        setLoading(false);
      }
    }

  }, [siteId, liffAccessToken, refreshData, mallId, shopCode, history]);

  const animationEnded = useCallback(() => {
    const elements = document.querySelectorAll('.stamp-new');
    if (elements.length === 0) return;
    elements.forEach(e => {
      e.classList.remove('stamp-new');
    });
  }, []);

  const getActiveCard = useCallback((stampcard_id) => {
    if (stamp[stampcard_id] && stamp[stampcard_id][0]) {
      return stamp[stampcard_id][0];
    } else {
      return {};
    }
  }, [stamp]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  useEffect(() => {
    if (imageRef.current) {
      imageRef.current.onanimationend = animationEnded;
    }
  }, [stampCardMaster, animationEnded]);

  const renderStamp = (stamp, idx, col) =>
    <div className={`col px-1 text-center align-self-center stamp-${idx + col < stamp.length ? (stamp[idx + col] ? '' : 'off') : 'null'}`}>
      <p className={`mb-0 mx-auto ${(stamp[idx + col] && stamp[idx + col].new) ? 'stamp-new' : ''}`} ref={(stamp[idx + col] && stamp[idx + col].new) ? imageRef : null}>{idx + col < stamp.length ? (stamp[idx + col] ? <img className="w-100" src={`/${siteId}/${constClass.STAMP_IMAGE_DIR}${stamp[idx + col].image}`} alt={''} /> : (idx + col + 1)) : ''}</p>
    </div>
  return (
    <React.Fragment>
      {(!point && !ticket) &&
        <div id="stampcard" className="frame50 mt-2">
          {stampCardMaster.map(stampCard => (
            <React.Fragment key={stampCard.stampcard_id}>
              <div className="row mx-0 mb-4">
                <div className="col mx-3 my-1 p-0 text-left bg-lightwhite rounded">
                  {stamp[stampCard.stampcard_id] && stamp[stampCard.stampcard_id][0] &&
                    <div className="row" key={0}>
                      <div className="col">
                        <div className={`bg-stamp stampcardrounded`}>
                          <div className="row px-3 py-2">
                            <div className="col text-center text-white">
                              {stampCard.stampcard_name ? (
                                <span className="mr-1"><h5>{stampCard.stampcard_name}</h5></span>) : null}
                              <span>{stamp[stampCard.stampcard_id][0].checkUsed ? '受け取り済み' : stamp[stampCard.stampcard_id][0].checkFilled ? '獲得スタンプ' : '獲得スタンプ'}</span>
                            </div>
                          </div>
                          <div className={`row px-3 py-4 ${stamp[stampCard.stampcard_id][0].checkUsed ? 'opacity' : ''}`}>
                            <div className="col">
                              {stamp[stampCard.stampcard_id][0].stamp.map((s, idx) => (
                                idx % 5 === 0 ? (
                                  <div className="row my-1" key={idx}>
                                    {renderStamp(stamp[stampCard.stampcard_id][0].stamp, idx, 0)}
                                    {renderStamp(stamp[stampCard.stampcard_id][0].stamp, idx, 1)}
                                    {renderStamp(stamp[stampCard.stampcard_id][0].stamp, idx, 2)}
                                    {renderStamp(stamp[stampCard.stampcard_id][0].stamp, idx, 3)}
                                    {renderStamp(stamp[stampCard.stampcard_id][0].stamp, idx, 4)}
                                  </div>
                                ) : null
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                  <div className='stampcardframe49'>
                    <div className="row mx-0">
                      <div className="col mx-3 mt-3 mb-1 p-0">
                        <Link to={`/${siteId}/${mallId}${shopCode ? `/shop/${shopCode}` : ''}/?page=${constClass.STAMPSCAN}`} >
                          <button className="button btn-active w-100 py-2" disabled={getActiveCard(stampCard.stampcard_id).checkFilled || getActiveCard(stampCard.stampcard_id).checkUsed}>
                            カメラを起動してスタンプ獲得
                          </button>
                        </Link>
                      </div>
                    </div>
                    <div className="row mx-0">
                      <div className="col mx-3 mt-1 mb-3 p-0">
                        <button
                          disabled={!getActiveCard(stampCard.stampcard_id).checkFilled || getActiveCard(stampCard.stampcard_id).checkUsed}
                          className={`button w-100 py-2`}
                          onClick={() => submitStampCard(stampCard.stampcard_id, stampCard.questionnaire_id)}
                        >
                          特典を受け取る
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          ))}
        </div>
      }
      {(point || ticket) &&
        <div className="applottery-container">
          <div className="frame50">
            {point && ticket ?
              <img src={`/${siteId}/getpointticket.svg`} alt='getpointticket' className='w-100' />
              : point ?
                <img src={`/${siteId}/getpoint.svg`} alt='getpoint' className='w-100' />
                : ticket ?
                  <img src={`/${siteId}/getticket.svg`} alt='getticket' className='w-100' />
                  : null
            }
            {point && ticket &&
              <div className="applotterypointcouponframe49">
                <div className="frame11">
                  <div className="points-held">
                    獲得ポイント
                  </div>
                  <div className="lottery-frame9">
                    <div className="lottery-points">
                      {getPoint}
                    </div>
                  </div>
                  <div className="applottery-text3">
                    おめでとうございます！<br />
                    ポイントとsssssクーポンを<br />
                    ゲットしました。
                  </div>
                  <button
                    onClick={() => ticketClick()}
                    className="button mt-3 text-black bg-white">
                    クーポンを表示する
                  </button>
                </div>
              </div>
            }
            {point && !ticket &&
              <div className="applotterypointframe49">
                <div className="frame11">
                  <div className="points-held">
                    獲得ポイント
                  </div>
                  <div className="lottery-frame9">
                    <div className="lottery-points">
                      {getPoint}
                    </div>
                  </div>
                  <div className="applottery-text3">
                    おめでとうございます！<br />
                    ポイントをゲットしました。
                  </div>
                </div>
              </div>
            }
            {ticket && !point &&
              <div className="applotterypointframe49">
                <div className="frame11">
                  <div className="applottery-text3 my-2">
                    おめでとうございます！<br />
                    クーポンをゲットしました。
                  </div>
                  <button
                    onClick={() => ticketClick()}
                    className="button mt-3 text-black bg-white">
                    クーポンを表示する
                  </button>
                </div>
              </div>
            }
          </div>
        </div>
      }
      {loading && <Loading />}
    </React.Fragment>
  );
}

export default StampCard;